(function() {
	const checkBtn = document.getElementById("imei-esim-compatibility-btn");
	const imeiInput = document.getElementById("esim-compatibility-input");
	const resultCnt = document.getElementById("imei-esim-check-result");
	const lengthError = document.getElementById("imei-length-error");
	const spinner = document.getElementById("compatibility-check-spinner");

	checkBtn.addEventListener("click", function() {

		if ( imeiInput.value.trim().length != 8 ) {

			lengthError.classList.remove("hidden");
			resultCnt.classList.add("hidden");
			return false;
		}

		this.disabled = true;
		spinner.classList.remove("hidden");
		spinner.classList.add("inline-block");

		axios.post("/search-esim-compatibility-by-imei", {
			imei: imeiInput.value
		})
		.then( res => {

			resultCnt.innerHTML = res.data;
			lengthError.classList.add("hidden");
			resultCnt.classList.remove("hidden");
		})
		.catch( err => {
			console.log(err);
		})
		.then( () => {
			this.disabled = false;
			spinner.classList.remove("inline-block");
			spinner.classList.add("hidden");
		})
	});

	imeiInput.addEventListener("input", function() {

		lengthError.classList.add("hidden");
		resultCnt.classList.add("hidden");
		this.value = this.value.replace(/[^0-9]/g, "");
	});
})();